import React from 'react';

export const ContactProfileModal = ({
  show,
  onClose,
  contactProfile,
  displayGaiaID,
  t,
  showChatActions = false,
  onToggleBlock,
  onReport,
  onClearChat,
  onCloseChat
}) => {
  if (!show || !contactProfile) return null;

  const trustPassport = contactProfile.trustPassport || {};
  const abuseScore = contactProfile.abuseScore || { score: 0, escalationLevel: 0 };
  const keyHistory = contactProfile.keyHistory || [];
  const fingerprint = trustPassport.fingerprint || contactProfile.publicKey?.slice(0, 64) || 'Unbekannt';

  let reputationColor = 'var(--success)';
  let reputationLabel = t('vertrauenswuerdig') || 'Vertrauenswuerdig';
  if (abuseScore.score > 10 && abuseScore.score <= 50) {
    reputationColor = 'var(--warning)';
    reputationLabel = t('auffaellig') || 'Auffaellig';
  } else if (abuseScore.score > 50) {
    reputationColor = 'var(--danger)';
    reputationLabel = t('gesperrt_verdaechtig') || 'Gesperrt / Verdaechtig';
  }

  const handleCopyFingerprint = () => {
    if (!fingerprint || !navigator?.clipboard?.writeText) return;
    navigator.clipboard.writeText(fingerprint).catch(() => {});
  };

  return (
    <div className="popup-overlay" style={{ zIndex: 1100 }}>
      <div className="popup-card glass-panel contact-profile-modal">
        <div className="contact-profile-header">
          <div>
            <div className="contact-profile-eyebrow">GaiaCOM Trust Passport</div>
            <h2 className="contact-profile-title">{contactProfile.displayName}</h2>
            <div className="contact-profile-id">{displayGaiaID(contactProfile.gaiaID)}</div>
          </div>
          <button type="button" className="chat-icon-btn" onClick={onClose} aria-label="Schliessen">
            {'\u2715'}
          </button>
        </div>

        <div className="contact-profile-hero">
          <div className="contact-profile-avatar">{'\u{1F464}'}</div>
          <div className="contact-profile-hero-copy">
            <div className="contact-profile-status-row">
              <span className="contact-profile-status-label">Reputation</span>
              <strong style={{ color: reputationColor }}>{reputationLabel}</strong>
            </div>
            <div className="contact-profile-status-row">
              <span className="contact-profile-status-label">Abuse Score</span>
              <strong>{abuseScore.score} / Lvl {abuseScore.escalationLevel}</strong>
            </div>
            <div className="contact-profile-status-row">
              <span className="contact-profile-status-label">Trust Age</span>
              <strong>{trustPassport.trustAgeDays !== undefined ? `${trustPassport.trustAgeDays} ${t('tage') || 'Tage'}` : `0 ${t('tage') || 'Tage'}`}</strong>
            </div>
          </div>
        </div>

        <div className="contact-profile-grid">
          <div className="contact-profile-panel">
            <span>Node Reputation</span>
            <strong>{trustPassport.nodeReputation || 'local-verified'}</strong>
          </div>
          <div className="contact-profile-panel">
            <span>Key Status</span>
            <strong>{keyHistory[0]?.confirmed ? (t('bestaetigt') || 'Bestaetigt') : (t('unbestaetigt') || 'Unbestaetigt')}</strong>
          </div>
        </div>

        <div className="contact-profile-panel">
          <div className="contact-profile-panel-header">
            <span>{t('cryptographic_fingerprint') || 'Kryptographischer Fingerprint'}</span>
            <button type="button" className="btn-secondary compact-btn" onClick={handleCopyFingerprint}>
              {t('copy') || 'Kopieren'}
            </button>
          </div>
          <code className="contact-profile-fingerprint">{fingerprint}</code>
        </div>

        {showChatActions && (
          <div className="contact-profile-panel">
            <div className="contact-profile-panel-header">
              <span>Chat Aktionen</span>
            </div>
            <div className="contact-profile-actions">
              <button type="button" className="btn-secondary compact-btn" onClick={onToggleBlock}>
                {contactProfile.blocked ? 'Kontakt freigeben' : 'Kontakt blockieren'}
              </button>
              <button type="button" className="btn-secondary compact-btn" onClick={onReport}>
                Melden
              </button>
              <button type="button" className="btn-secondary compact-btn" onClick={onClearChat}>
                Chat leeren
              </button>
              <button type="button" className="btn-secondary compact-btn" onClick={onCloseChat}>
                Chat schliessen
              </button>
            </div>
          </div>
        )}

        <div className="contact-profile-panel">
          <div className="contact-profile-panel-header">
            <span>{t('key_transparency') || 'Key Transparency'}</span>
          </div>
          <div className="contact-profile-history gaia-scrollbar">
            {keyHistory.length === 0 ? (
              <div className="contact-profile-history-empty">
                {t('no_key_history') || 'Keine Schluessel-Historie aufgezeichnet.'}
              </div>
            ) : (
              keyHistory.map((historyEntry, index) => (
                <div key={`${historyEntry.fingerprint || historyEntry.publicKey || index}-${index}`} className="contact-profile-history-item">
                  <div className="contact-profile-history-top">
                    <strong>{historyEntry.type ? historyEntry.type.toUpperCase() : 'IDENTITY_KEY'}</strong>
                    <span style={{ color: historyEntry.confirmed ? 'var(--success)' : 'var(--warning)' }}>
                      {historyEntry.confirmed ? (t('bestaetigt') || 'Bestaetigt') : (t('unbestaetigt') || 'Unbestaetigt')}
                    </span>
                  </div>
                  <code>FP: {historyEntry.fingerprint || `${historyEntry.publicKey?.slice(0, 32) || ''}...`}</code>
                  <small>
                    Aktiv von: {historyEntry.firstSeenAt ? new Date(historyEntry.firstSeenAt).toLocaleDateString() : 'Anfang'} - {historyEntry.lastSeenAt ? new Date(historyEntry.lastSeenAt).toLocaleDateString() : 'Aktiv'}
                  </small>
                  {historyEntry.warning && (
                    <div className="contact-profile-warning">
                      {t('warnung') || 'Warnung'}: {historyEntry.warning}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactProfileModal;
